module.exports = __webpack_public_path__ + "officialStatic/img/znsbDetailList1.27c9194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/znsbDetailList1.png
// module id = BwMM
// module chunks = 0